import { useEffect, useRef } from 'react';
import { formActivity } from './formActivity';

// Retain the draft guard after focus leaves an inline editor, until it closes.
export default function useRealtimeDraft(dirty) {
  const owner = useRef(Symbol('realtime-draft'));
  useEffect(() => {
    const key = owner.current;
    formActivity.draft(key, Boolean(dirty));
    return () => formActivity.draft(key, false);
  }, [dirty]);
}
